module.exports = __webpack_public_path__ + "static/img/classroom_4.e41e3d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/classroom_4.jpg
// module id = YLKd
// module chunks = 3